import { createSelector } from '@ngrx/store';
import * as fromFeature from '../../reducers.index';
import { StoreFinderState } from '../reducers/store-finder.reducer';

export const selectStoreFinder = createSelector(
  fromFeature.getStoreState,
  (state: fromFeature.BoelsState) => state.storeFinder,
);

export const selectActiveStoreFinder = createSelector(
  selectStoreFinder,
  (state: StoreFinderState) => state.active,
);

export const selectActiveRegion = createSelector(
  selectStoreFinder,
  (state: StoreFinderState) => state.region,
);

export const selectSpecialismList = createSelector(
  selectStoreFinder,
  (state: StoreFinderState) => state.specialism,
);
